import React, { useContext, useEffect, useState } from 'react';
import snapshotGroupimg from '../../../../Assets/Images/snapshotGroupImg.png';
import flow_HM from '../../../../Assets/Images/flowScoreIcons/H-M.png'
import flow_HS from '../../../../Assets/Images/flowScoreIcons/H-S.png'
import flow_HST from '../../../../Assets/Images/flowScoreIcons/H-ST.png'
import flow_MH from '../../../../Assets/Images/flowScoreIcons/M-H.png'
import flow_MS from '../../../../Assets/Images/flowScoreIcons/M-S.png'
import flow_MST from '../../../../Assets/Images/flowScoreIcons/M-ST.png'
import flow_SH from '../../../../Assets/Images/flowScoreIcons/S-H.png'
import flow_SM from '../../../../Assets/Images/flowScoreIcons/S-M.png'
import flow_SST from '../../../../Assets/Images/flowScoreIcons/S-ST.png'
import flow_STH from '../../../../Assets/Images/flowScoreIcons/ST-H.png'
import flow_STM from '../../../../Assets/Images/flowScoreIcons/ST-M.png'
import flow_STS from '../../../../Assets/Images/flowScoreIcons/ST-S.png'
import overviewImg from '../../../../Assets/Images/Overview.png'
import logo1 from '../../../../Assets/Images/logo1.png'
import logo5 from '../../../../Assets/Images/logo5.png'
import logo6 from '../../../../Assets/Images/logo6.png'
import logo7 from '../../../../Assets/Images/logo7.png'
import collaborativelogo from '../../../../Assets/Images/COLLABORATIVE.png'
import stratrgiclogo from '../../../../Assets/Images/STRATEGIC.png'
import visionarylogo from '../../../../Assets/Images/VISIONARY.png'
import performancelogo from '../../../../Assets/Images/PERFORMANCE.png'
import GrowthLogo from '../../../../Assets/Images/growth-new.png'
import FixedLogo from '../../../../Assets/Images/fixed-new.png'
import ConditionalLogo from '../../../../Assets/Images/conditional_edit.png'
import GroupStarterQuadrantChartPreview from '../groupReport-pdf/GroupStarterQuadrantChartPreview';  
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import FooterPreview from '../../../GeneratePdf/FooterPreview';
import GroupReportContext from '../../../../Context/GroupReportContext';
import { getMindsetSum, categorizeMindset } from '../../../../utils/helper';
import { applyFullTieOrder } from '../../../../utils/quadrantTieOrder';

export default function SnapshotImgPreview360({ apiData, isGroupReport = false, reportType, pageNumber }) {
  
  const [results, setResults] = useState({
    self: {
      starter: '',
      flow: '',
      leadership: '',
      leadershipPercentages: null,
      mindset: ''
    },
    others: {
      starter: '',
      flow: '',
      leadership: '',
      leadershipPercentages: null,
      mindset: ''
    }
  });

  const [quadrantData, setQuadrantData] = useState(null);
  const [isQuadrantDataReceived, setIsQuadrantDataReceived] = useState(false);

  const { averagePercentages, starterFlow, averagePercentagesLeadership, averagePercentagesLeadershipSelf, averagePercentagesSelf,averagePercentagesMindset, averagePercentagesMindsetSelf, getPercentileFromScore } = useContext(GroupReportContext)
  const starterFlow360 = applyFullTieOrder(averagePercentages?.slice().sort((a,b) => b.avg - a.avg ), el => el.name, el => el.avg)
  const starterFlowSelf = applyFullTieOrder(averagePercentagesSelf?.slice().sort((a,b) => b.avg - a.avg ), el => el.name, el => el.avg)
  const starterFlowLeadershipSelf = applyFullTieOrder(averagePercentagesLeadershipSelf?.slice().sort((a,b) => b.avg - a.avg ), el => el.name, el => el.avg)
  const starterFlowLeadership = applyFullTieOrder(averagePercentagesLeadership?.slice().sort((a,b) => b.avg - a.avg ), el => el.name, el => el.avg)
  const handleQuadrantData = (data) => {

    // console.log('Received quadrant data:', data);
    setQuadrantData(data);
    setIsQuadrantDataReceived(true);
  };

  // Build stable dependency keys to avoid effect thrashing on object identity changes

  // Process API data for both SELF and 360 (Others) assessments
  useEffect(() => {
    if (!apiData?.data && !apiData?.variables) {
      // console.log('No API data available');
      return;
    }
  
    // console.log('Processing API data for SELF and 360');
  
    const processedResults = {
      self: {
        starter: '',
        flow: '',
        leadership: '',
        leadershipPercentages: null,
        mindset: ''
      },
      others: {
        starter: '',
        flow: '',
        leadership: '',
        leadershipPercentages: null,
        mindset: ''
      }
    };

    // Handle Group Report data (multiple assessments)
    if (isGroupReport && apiData?.data) {
    const allLeadershipScores = {
      collaborative: [],
      strategic: [],
      visionary: [],
      performance: []
    };
  
    const allMindsetScores = [];
  
      // For group starter/flow calculation
      const allStarterScores = {
        heart: [],
        soul: [],
        mind: [],
        strength: []
      };
      
      // Process each assessment for group average
      Object.values(apiData.data).forEach((assessment, index) => {
        if (!assessment?.variables) return;
      
      const variables = assessment.variables;
      
        // Collect mindset scores
      const mindsetSum = getMindsetSum(variables);
      if (mindsetSum > 0) {
        allMindsetScores.push(mindsetSum);
      }
  
        // Collect leadership scores
      const leadershipScores = {
        collaborative: 0,
        strategic: 0,
        visionary: 0,
        performance: 0
      };
  
      variables.forEach(v => {
        if (v.variable === "col_round1_m") leadershipScores.collaborative = v.score || 0;
        if (v.variable === "strat_round1_m") leadershipScores.strategic = v.score || 0;
        if (v.variable === "vis_round1_m") leadershipScores.visionary = v.score || 0;
        if (v.variable === "per_round1_m") leadershipScores.performance = v.score || 0;
      });
  
        // Add to arrays for average calculation
      allLeadershipScores.collaborative.push(leadershipScores.collaborative);
      allLeadershipScores.strategic.push(leadershipScores.strategic);
      allLeadershipScores.visionary.push(leadershipScores.visionary);
      allLeadershipScores.performance.push(leadershipScores.performance);
        
        // Collect starter scores
        const starterScores = {
          heart: 0,
          soul: 0,
          mind: 0,
          strength: 0
        };

        variables.forEach(v => {
          if (v.variable === "heart_round1_m") starterScores.heart += v.score || 0;
          if (v.variable === "heart_round2_m") starterScores.heart += v.score || 0;
          if (v.variable === "soul_round1_m") starterScores.soul += v.score || 0;
          if (v.variable === "soul_round2_m") starterScores.soul += v.score || 0;
          if (v.variable === "mind_round1_m") starterScores.mind += v.score || 0;
          if (v.variable === "mind_round2_m") starterScores.mind += v.score || 0;
          if (v.variable === "str_round1_m") starterScores.strength += v.score || 0;
          if (v.variable === "str_round2_m") starterScores.strength += v.score || 0;
        });

        // Add to arrays for average calculation
        allStarterScores.heart.push(starterScores.heart);
        allStarterScores.soul.push(starterScores.soul);
        allStarterScores.mind.push(starterScores.mind);
        allStarterScores.strength.push(starterScores.strength);
      });

      // Calculate averages for leadership
    const leadershipAverages = {};
    Object.keys(allLeadershipScores).forEach(style => {
      const scores = allLeadershipScores[style];
        leadershipAverages[style] = scores.length > 0 
          ? scores.reduce((sum, score) => sum + score, 0) / scores.length 
          : 0;
      });

      // Calculate averages for starters
      const starterAverages = {};
      Object.keys(allStarterScores).forEach(starter => {
        const scores = allStarterScores[starter];
        starterAverages[starter] = scores.length > 0 
          ? scores.reduce((sum, score) => sum + score, 0) / scores.length 
          : 0;
      });

      // Find highest and second highest starters
      const sortedStarters = Object.entries(starterAverages)
        .sort(([,a], [,b]) => b - a);
      
      const [highestStarter] = sortedStarters[0] || [];
      const [secondHighestStarter] = sortedStarters[1] || [];

    const mindsetAverage = allMindsetScores.length > 0 
      ? allMindsetScores.reduce((sum, score) => sum + score, 0) / allMindsetScores.length 
      : 0;
  
      // Determine results for group
      const maxAverage = Math.max(...Object.values(leadershipAverages));
      const highestLeadership = Object.entries(leadershipAverages)
        .find(([, average]) => average === maxAverage)?.[0];
  
    const mindsetPercentage = getPercentileFromScore(mindsetAverage);
    const averageMindset = categorizeMindset(Math.round(mindsetPercentage));
    processedResults.self.mindset = averageMindset || '';
      
      // Calculate flow for group
      if (highestStarter && secondHighestStarter) {
        processedResults.self.flow = `${highestStarter}_to_${secondHighestStarter}`;
      }
      
      // console.log('Group report results:', processedResults);
    }
    
    // Handle Single 360 Assessment data
    else if (apiData?.variables) {
      const variableMap = apiData.variables.reduce((acc, el) => {
        acc[el.variable] = el.score;
        return acc;
      }, {});

      // console.log('Processing 360 variables:', variableMap);

      // Process SELF data (round1_m, round2_m variables)
      const selfResults = processSingleAssessment(variableMap, 'self');
      processedResults.self = selfResults;

      // Process 360/OTHERS data if available
      if (apiData?.memberResults?.allMembersData) {
        const othersLeadershipPercentages = getAggregatedOthersLeadership(apiData.memberResults.allMembersData);
        processedResults.others.leadershipPercentages = othersLeadershipPercentages;
        if (othersLeadershipPercentages) {
          processedResults.others.leadership = Object.entries(othersLeadershipPercentages).sort((a, b) => b[1] - a[1])[0][0];
        }
      }
      // Process 360/OTHERS starter, flow, mindset (optional: can be implemented similarly if needed)
      // For now, keep as before
    // console.log("starterFlowLeadership,starterFlowLeadershipSelf,averagePercentagesLeadershipSelf",starterFlowLeadership,starterFlowLeadershipSelf,averagePercentagesLeadershipSelf,averagePercentagesLeadership)
      const othersResults = processSingleAssessment(variableMap, 'others');

      processedResults.self.starter = starterFlowSelf?.[0]?.name || '';
      processedResults.self.leadership = starterFlowLeadershipSelf?.[0]?.name || '';
      processedResults.self.flow = `${starterFlowSelf?.[0]?.name.toLowerCase()}_to_${starterFlowSelf?.[1]?.name.toLowerCase()}`;
      processedResults.self.mindset = selfResults.mindset;

      processedResults.others.starter = starterFlow360?.[0]?.name;
      processedResults.others.leadership = starterFlowLeadership?.[0]?.name || '';
      processedResults.others.flow = `${starterFlow360?.[0]?.name.toLowerCase()}_to_${starterFlow360?.[1]?.name.toLowerCase()}`;
      processedResults.others.mindset = othersResults.mindset;
      // Note: leadership for others is now set by aggregation above
      
      // console.log('360 assessment results:', processedResults);
    }

    // Update quadrant data from child component for starter and flow (only for group reports if needed)
    // Note: We now calculate starter and flow directly, so this is mainly for backup/validation
    if (quadrantData && isQuadrantDataReceived && isGroupReport) {
      // This can be used for validation or as fallback if needed
      // console.log('Quadrant data received for validation:', quadrantData);
    }

    // Avoid redundant state updates to prevent render loops

    setResults((prev) => {
      if (!prev) return processedResults;
      // Compare the actual objects instead of stringifying
      if (prev.self.starter !== processedResults.self.starter ||
          prev.self.flow !== processedResults.self.flow ||
          prev.self.leadership !== processedResults.self.leadership ||
          prev.self.mindset !== processedResults.self.mindset ||
          prev.others.starter !== processedResults.others.starter ||
          prev.others.flow !== processedResults.others.flow ||
          prev.others.leadership !== processedResults.others.leadership ||
          prev.others.mindset !== processedResults.others.mindset) {
        return processedResults;
      }
      return prev;
    });
  }, [isGroupReport, apiData?.variables, apiData?.data, apiData?.memberResults?.allMembersData]);


  // Helper function to process single assessment data
  const processSingleAssessment = (variableMap, type) => {
    const result = {
      starter: '',
      flow: '',
      leadership: '',
      mindset: ''
    };

    // Determine variable suffix based on type
    const suffix = type === 'self' ? 'm' : 'o'; // assuming 'o' for others, adjust as needed

    // Process Starter data
    const starterScores = {
      heart: (variableMap[`heart_round1_${suffix}`] || 0) + (variableMap[`heart_round2_${suffix}`] || 0),
      soul: (variableMap[`soul_round1_${suffix}`] || 0) + (variableMap[`soul_round2_${suffix}`] || 0),
      mind: (variableMap[`mind_round1_${suffix}`] || 0) + (variableMap[`mind_round2_${suffix}`] || 0),
      strength: (variableMap[`str_round1_${suffix}`] || 0) + (variableMap[`str_round2_${suffix}`] || 0)
    };

    // Find highest and second highest for starter and flow
    const starterPriority = { heart: 1, mind: 2, soul: 3, strength: 4 };
    const sortedStarters = Object.entries(starterScores)
      .sort((a, b) => {
        if (b[1] !== a[1]) return b[1] - a[1];
        return starterPriority[a[0]] - starterPriority[b[0]];
      });
    
    const [highestStarter] = sortedStarters[0] || [];
    const [secondHighestStarter] = sortedStarters[1] || [];
    
    result.starter = highestStarter || '';
    
    // Calculate flow (highest to second highest)
    if (highestStarter && secondHighestStarter) {
      result.flow = `${highestStarter}_to_${secondHighestStarter}`;
    }

    // Process Leadership data (for self only, 360/others handled separately)
    if (type === 'self') {
      const leadershipScores = {
        collaborative: Math.max(
          variableMap['col_round1_m'] || 0,
          variableMap['col_round2_m'] || 0,
          variableMap['col_round1_l'] || 0,
          variableMap['col_round2_l'] || 0
        ),
        strategic: Math.max(
          variableMap['strat_round1_m'] || 0,
          variableMap['strat_round2_m'] || 0,
          variableMap['strat_round1_l'] || 0,
          variableMap['strat_round2_l'] || 0
        ),
        performance: Math.max(
          variableMap['per_round1_m'] || 0,
          variableMap['per_round2_m'] || 0,
          variableMap['per_round1_l'] || 0,
          variableMap['per_round2_l'] || 0
        ),
        visionary: Math.max(
          variableMap['vis_round1_m'] || 0,
          variableMap['vis_round2_m'] || 0,
          variableMap['vis_round1_l'] || 0,
          variableMap['vis_round2_l'] || 0
        )
      };
      const maxLeadership = Math.max(...Object.values(leadershipScores));
      result.leadership = Object.entries(leadershipScores).find(([, score]) => score === maxLeadership)?.[0] || '';
    }

    // Process Mindset data
    const mindsetScore = type === "self" ? averagePercentagesMindsetSelf : averagePercentagesMindset;
    result.mindset = categorizeMindset(Math.round(mindsetScore));

    return result;
  };

  // Helper function to aggregate 360/others leadership
  const getAggregatedOthersLeadership = (allMembersData) => {
    const leadershipSums = {
      performance: 0,
      strategic: 0,
      visionary: 0,
      collaborative: 0
    };
    let memberCount = 0;
    Object.values(allMembersData).forEach(member => {
      if (!member?.variables) return;
      const variableMap = member.variables.reduce((acc, el) => {
        acc[el.variable] = el.score;
        return acc;
      }, {});
      // Calculate leadership percentages for this member (same as self logic)
      const performance_r1_m = variableMap["per_round1_m"] || 0;
      const strategic_r1_m = variableMap["strat_round1_m"] || 0;
      const visionary_r1_m = variableMap["vis_round1_m"] || 0;
      const collaborative_r1_m = variableMap["col_round1_m"] || 0;

      const performance_r2_m = variableMap["per_round2_m"] || 0;
      const strategic_r2_m = variableMap["strat_round2_m"] || 0;
      const visionary_r2_m = variableMap["vis_round2_m"] || 0;
      const collaborative_r2_m = variableMap["col_round2_m"] || 0;

      const performance_r1_l = variableMap["per_round1_l"] || 0;
      const strategic_r1_l = variableMap["strat_round1_l"] || 0;
      const visionary_r1_l = variableMap["vis_round1_l"] || 0;
      const collaborative_r1_l = variableMap["col_round1_l"] || 0;

      const performance_r2_l = variableMap["per_round2_l"] || 0;
      const strategic_r2_l = variableMap["strat_round2_l"] || 0;
      const visionary_r2_l = variableMap["vis_round2_l"] || 0;
      const collaborative_r2_l = variableMap["col_round2_l"] || 0;

      let most_score = Math.max(performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m);
      let second_most_score = Math.max(performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m) / 2;
      let least_score = Math.max(performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l);
      let second_least_score = Math.max(performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l) / 2;

      if (least_score >= second_least_score) {
        least_score = second_least_score - 1;
      }

      const total = most_score + second_most_score + least_score + second_least_score;
      if (total === 0) return; // skip this member if all scores are zero

      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100;

      const labels_arr = ["performance", "strategic", "visionary", "collaborative"];
      const mostValues = [performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m];
      const secondMostValues = [performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m];
      const leastValues = [performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l];
      const secondLeastValues = [performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l];

      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];
      const most_label = getLabel(mostValues, Math.max(...mostValues));
      const second_most_label = getLabel(secondMostValues, Math.max(...secondMostValues));
      const least_label = getLabel(leastValues, Math.max(...leastValues));
      const second_least_label = getLabel(secondLeastValues, Math.max(...secondLeastValues));

      // Assign percentages to the correct style
      const leadershipPercentages = {
        performance: 0,
        strategic: 0,
        visionary: 0,
        collaborative: 0
      };
      leadershipPercentages[most_label] = most_per;
      leadershipPercentages[second_most_label] = second_most_per;
      leadershipPercentages[least_label] = least_per;
      leadershipPercentages[second_least_label] = second_least_per;

      // Add to sums
      leadershipSums.performance += leadershipPercentages.performance;
      leadershipSums.strategic += leadershipPercentages.strategic;
      leadershipSums.visionary += leadershipPercentages.visionary;
      leadershipSums.collaborative += leadershipPercentages.collaborative;
      memberCount++;
    });
    if (memberCount === 0) return null;
    // Average the percentages
    const avgPercentages = {
      performance: leadershipSums.performance / memberCount,
      strategic: leadershipSums.strategic / memberCount,
      visionary: leadershipSums.visionary / memberCount,
      collaborative: leadershipSums.collaborative / memberCount
    };
    return avgPercentages;
  };

  // Helper functions for logos and images
  const getStarterLogo = (starter) => {
    // console.log('Getting starter logo for:', starter);
    if (starter.toLowerCase() === "heart") return logo1;
    if (starter.toLowerCase() === "strength") return logo5;
    if (starter.toLowerCase() === "soul") return logo7;
    if (starter.toLowerCase() === "mind") return logo6;
    return logo1;
  };

  const getFlowImage = (flow) => {
    // console.log('Getting flow image for:', flow);
    const images = {
      heart_to_soul: flow_HS,
      heart_to_mind: flow_HM,
      heart_to_strength: flow_HST,
      mind_to_heart: flow_MH,
      mind_to_soul: flow_MS,
      mind_to_strength: flow_MST,
      soul_to_heart: flow_SH,
      soul_to_mind: flow_SM,
      soul_to_strength: flow_SST,
      strength_to_heart: flow_STH,
      strength_to_mind: flow_STM,
      strength_to_soul: flow_STS,
    };
    return images[flow] || overviewImg;
  };

  const getFlowHead = (flow) => {
    if (!flow) return '';
    // "soul_to_heart" -> "Soul to Heart": the connector stays lowercase, as in the PDF.
    const formatted = flow.split('_').map(word =>
      word === 'to' ? word : word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
    return formatted;
  };

  const getLeadershipLogo = (type) => {
    if (!type) return collaborativelogo;

    const normalized = type.trim().toLowerCase();

    if (normalized === 'collaborative') return collaborativelogo;
    if (normalized === 'strategic') return stratrgiclogo;
    if (normalized === 'performance') return performancelogo;
    if (normalized === 'visionary') return visionarylogo;

    return collaborativelogo;
  };

  const getMindsetLogo = (category) => {
    // console.log('Getting mindset logo for:', category);
    switch (category) {
      case "growth":
        return GrowthLogo;
      case "conditional":
        return ConditionalLogo;
      case "fixed":
        return FixedLogo;
      default:
        return GrowthLogo;
    }
  };

  const renderQuadrantContent = (category, selfValue, othersValue) => {
    const hasOthers = othersValue && !isGroupReport;
    
    return (
      <div style={{ 
        minWidth: "208px", 
        maxWidth: "208px", 
        display: 'flex', 
        justifyContent: "center", 
        alignItems: "center", 
        flexDirection: "column", 
        border: "2px solid #00577D", 
        padding: "20px 15px", 
        borderRadius: "10px", 
        position: "relative", 
        margin: "0 auto",
        height: "73px",
        padding: "16px",
        boxSizing: "border-box",
        fontFamily: "Helvetica"
      }}>
        <div style={{ 
          position: "absolute", 
          top: "-9px", 
          left: "50%",
          transform: "translateX(-50%)",
          textAlign: "center", 
          backgroundColor: "#FFFFFF", 
          padding: "0 16px", 
          fontSize: "11px", 
          color: "#000000",
          fontWeight: "700",
          fontFamily: "Helvetica",
          lineHeight: "15px"
        }}>
          {category}
        </div>
        
        <div style={{
          display: 'flex',
          flexDirection: 'row', // change to row for two columns
          alignItems: 'center',
          justifyContent: 'start',
          gap: '8px',
        }}>
          {/* Icons column */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}>
            {selfValue && (
              <img 
                src={getLogo(category, selfValue)} 
                alt="" 
                style={{ 
                  width: "16px", 
                  height: "16px", 
                  borderRadius: "50%",
                  flexShrink: 0
                }} 
              />
            )}
            {hasOthers && (
              <img 
                src={getLogo(category, othersValue)} 
                alt="" 
                style={{ 
                 width: "16px", 
                  height: "16px", 
                  borderRadius: "50%",
                  flexShrink: 0
                }} 
              />
            )}
          </div>
          {/* Text column */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: '10px',
          }}>
            {selfValue && (
              <div style={{ 
                fontSize: "11px", 
                lineHeight: "15px", 
                fontFamily: "Helvetica", 
                fontWeight: "400", 
                color: "#000000",
                textAlign: "left",
                display: 'flex',
                alignItems: 'center',
              }}>
                SELF: {getDisplayText(category, selfValue)}
              </div>
            )}
            {hasOthers && (
              <div style={{ 
                fontSize: "11px", 
                lineHeight: "15px", 
                fontFamily: "Helvetica", 
                fontWeight: "400", 
                color: "#000000",
                textAlign: "left",
                display: 'flex',
                alignItems: 'center',
              }}>
                360: {getDisplayText(category, othersValue)}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const getLogo = (category, value) => {
    switch (category) {
      case 'Starter':
        return getStarterLogo(value);
      case 'Flow':
        return getFlowImage(value);
      case 'Leadership':
        return getLeadershipLogo(value);
      case 'Mindset':
        return getMindsetLogo(value);
      default:
        return logo1;
    }
  };

  const getDisplayText = (category, value) => {
    switch (category) {
      case 'Starter':
        return value ? `${value.charAt(0).toUpperCase() + value.slice(1)}-Starter` : '';
      case 'Flow':
        return getFlowHead(value);
      case 'Leadership':
        return value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
      case 'Mindset':
        return value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
      default:
        return value;
    }
  };

  // console.log("results",results)
  // console.log("averagePercentagesLeadershipSelf, averagePercentagesLeadership",averagePercentagesLeadershipSelf, averagePercentagesLeadership)

  return (
    <div>
      <div className='group-snapshot-results' style={{ 
        fontFamily: "Helvetica, sans-serif", 
        backgroundColor: "#ffffff", 
        color: "#245775" 
      }}>

        <div style={{ gap: "21px", marginTop: "20px"}}>
          <div style={{ 
            maxWidth: "440px", 
            gap: "24px", 
            flexDirection: "column", 
            paddingTop: "0px" 
          }}>
            <div style={{ 
              display: 'flex', 
              flexDirection: "row", 
              gap: "25px", 
              alignItems: "stretch", 
              marginBottom: '35px' 
            }}>
              {renderQuadrantContent('Starter', results.self.starter, results.others.starter)}
              {renderQuadrantContent('Flow', results.self.flow, results.others.flow)}
            </div>
            
            <div style={{ 
              display: 'flex', 
              flexDirection: "row", 
              gap: "25px", 
              alignItems: "stretch" 
            }}>
              {renderQuadrantContent('Leadership', results.self.leadership, results.others.leadership)}
              {renderQuadrantContent('Mindset', results.self.mindset, results.others.mindset)}
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
}

